<template>
	<div id="invitation-jgz" :class="'page_'+theme">
		<div class="h1">{{ $t('invite.invite_xp') }} </div>
		<div class="ewm">
			<div class="left">
				<img class="icon" :src="imgList[2]" />
				<span class="icon2">
					<img :src="httpImg + imgList[1]" />
				</span>
			</div>
			<div class="right">
				<img :src="httpImg + `/invitation-xp/invite-17.png`" />
				<p>{{ $t('invite.scan_down_xp') }} JGZ App</p>
			</div>
			<img class="bg" :src="httpImg + `/invitation-xp/invite-bg5${theme == 'night' ? '-night':''}.svg`" alt="">
		</div>

		<div class="inputBox">
			<div class="text">{{$t('invite.invite_code')}}</div>
			<div @click="liClick(0)" class="num">{{inviteInfo.inviteCode}}
				<img :src="httpImg + `/invitation-xp/invite-3${theme == 'night' ? '-night':''}.png`" />
			</div>
		</div>
		<div class="inputBox">
			<div class="text">{{ $t('invite.invite_code_xp')}}</div>
			<div @click="liClick(1)" class="num"><span>{{inviteInfo.urlStr}}</span>
				<img :src="httpImg + `/invitation-xp/invite-3${theme == 'night' ? '-night':''}.png`" />
			</div>
		</div>


		<div class="h2"><span></span>{{$t('invite.invite_text_xp')}}<span></span></div>
		<div class="ul">
			<div v-for="(item,index) in ulList" @click="liClick(index,true)" class="li">
				<div class="img"><img :src="httpImg + (theme == 'night' ? item.img2:item.img)"></div>
				<p>{{$t(item.text)}}</p>
			</div>
		</div>

		<!-- 海报 -->
		<div :class="posterShow ? 'on':''" class="poster">
			<div v-if="canvasLoad" class="load">
				<img :src="httpImg + '/H5Img/loading.svg'" />
			</div>
			<img v-else class="hbImg" :src="canvasImg" />

			<div class="ul type-2">
				<div v-for="(item,index) in ulList2" @click="liClick(index + 3,true)" class="li">
					<div class="img"><img :src="httpImg + (theme == 'night' ? item.img2:item.img)"></div>
					<p>{{$t(item.text) }}</p>
				</div>
			</div>
		</div>
		<div :class="posterShow ? 'on':''" @click="liClick(2,false)" class="posterBG"></div>

		<div class="canvasRef" ref="qrcode"></div>
		<canvas id="canvasId" width="520" height="840" class="canvasRef"></canvas>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex';
	import QRCode from 'qrcodejs2'
	// import JgzLoading from '@/components/JgzLoading.vue'

	export default {
		name: 'Invitation',
		components: {},
		data() {
			return {
				isiOS: false,
				username: '',
				inviteInfo: {},
				message: '',
				alertShow: false,
				showLoading: false,
				myWindow: window,
				ulList: [{
						img: '/invitation-xp/invite-4.png',
						img2: '/invitation-xp/invite-4-night.png',
						text: 'invite.invite_code2_xp'
					},
					{
						img: '/invitation-xp/invite-5.png',
						img2: '/invitation-xp/invite-5-night.png',
						text: 'invite.invite_url_xp'
					},
					{
						img: '/invitation-xp/invite-6.png',
						img2: '/invitation-xp/invite-6-night.png',
						text: 'invite.invite_hb_xp'
					}
				],
				ulList2: [{
						img: '/invitation-xp/invite-7.png',
						img2: '/invitation-xp/invite-7-night.png',
						text: 'invite.invite_back'
					},
					{
						img: '/invitation-xp/invite-8.png',
						img2: '/invitation-xp/invite-8-night.png',
						text: 'invite.invite_save'
					},
				],
				posterShow: false,
				canvasImg: '',
				canvasLoad: true,
				qrcodeCanvas: '',
				imgList: [
					// '/invitation-xp/invite-bg6.png',
					`/invitation-xp/invite-bg-${this.$i18n.locale == 'zh' || this.$i18n.locale == 'zh-h' ? 'cn' : 'en'}.png`,
					'/invitation-xp/logo-jgz.png',
					
				],
			}
		},
		computed: {
			//获取用户信息
			...mapState('app', {
				theme: state => state.theme,
				httpImg: state => state.httpImg,
				DDNS: state => state.DDNS,
			}),
			// ...mapState('auth', {
			// 	user: state => state.user
			// }),
		},
		watch: {
			DDNS: {
				handler(val) {
					document.title = this.$route.query.title || `${this.$t('invite.invite_friend')}`;
			
					const u = navigator.userAgent;
					this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
					this.username = this.$route.query.username || this.$route.query.userId || 123456;
					let token = this.$route.query.auth || this.$route.query.token;
					// debugger
					token = decodeURI(token)
					this.$MyAxios.axiosInstance.defaults.headers.common['Authorization'] = token;

					this.showLoading = true;
					this.getUserData();
				},
				immediate: true,
				deep: true
			}
		},
		mounted() {
			// this.$store.state.app.theme
			// this.$router.push( {
			// 	name: 'error'
			// } )

			
		},
		methods: {
			//列表按钮
			liClick(i, type) {
				//复制邀请码
				if (i == 0) {
					this.$utils.copyInfo(this.inviteInfo.inviteCode)
				} else if (i == 1) { //复制链接
					this.$utils.copyInfo(this.inviteInfo.urlStr)
				} else if (i == 2) { //生成海报
					this.posterShow = type;
					if (type) {
						//画海报
						this.posterCanvas()
					}
				} else if (i == 4) {
					this.$utils.saveImg(this.canvasImg, '邀请好友')
				} else {
					this.posterShow = false;
				}
			},

			//画海报
			posterCanvas() {
				//开始画海报前的工作 下载所需图片
				if (!this.canvasImg) {
					this.canvasLoad = true;

					let i = 0;
					let list = []
					let This = this;
					this.imgList.forEach((src, index) => {
						let img = new Image();
						img.crossOrigin = 'Anonymous';
						img.onload = function() {
							i++
							list[index] = this
							if (This.imgList.length == i) {
								//图片加载完成
								This.imgCanvas(list).then(res => {
									This.canvasImg = res
									This.posterShow = true
									This.canvasLoad = false;
									// console.log(111,res)
								}).catch(err => {
									console.log(444, err)
									This.canvasLoad = false;
								})
							}
						}
						img.src = (src.startsWith('data:') || src.startsWith('http') ? '' : This.httpImg) + src;

					})

					console.log(32, this.canvasLoad)
				} else {
					//已有图片了
					this.posterShow = true
				}
			},

			//合成海报
			imgCanvas(src) {
				let This = this
				let fType = this.$i18n.locale
				return new Promise(function(resolve, reject) {
					try {

						let text = [];
						let textLeft = [120, 224];
						if (fType == 'zh') {
							text = ['扫码下载', '邀请码']
						} else if (fType == 'en') {
							text = ['Download QR', 'Invite Code']
							textLeft = [60, 200];
						} else {
							text = ['掃碼下載', '邀請碼']
						}

						let canvas = document.getElementById('canvasId');
						let ctx = canvas.getContext('2d');
						ctx.clearRect(0, 0, canvas.width, canvas.height);
						// 绘图开始
						// 画图片
						ctx.drawImage(src[0], 0, 0, 520, 840);
						ctx.save();
						//画二维码
						ctx.drawImage(src[2], 70, 234, 380, 380);
						ctx.save();
						//画logo的底 drawRoundRect(ctx, x, y, w, h, r, color) {
						This.drawRoundRect(ctx, 210, 375, 100, 100, 10, '#ffffff')
						// This.drawRoundRect(ctx, 220, 384, 80, 80, 20, '#121212')
						ctx.save();
						//画logo
						ctx.drawImage(src[1], 220, 387, 80, 80);
						ctx.save();
						// 画标题文字
						ctx.font = 'normal 400 36px sans-serif';
						ctx.fillStyle = "#ffffff"
						ctx.fillText(text[0] + ' JGZ App', textLeft[0], 170);
						ctx.save(); //保存
						//邀请码
						ctx.fillStyle = "#A1A6AE"
						ctx.font = 'normal 24px sans-serif';
						ctx.fillText(text[1], textLeft[1], 695);
						ctx.save(); //保存
						ctx.fillStyle = "#1E2329"
						ctx.font = 'normal bold 28px sans-serif';
						ctx.fillText(This.inviteInfo.inviteCode, 210, 740);
						ctx.save(); //保存


						// ctx.draw( false, () => {
						// 合成图片
						let url = canvas.toDataURL('image/jpeg', 0.8)
						resolve(url)
						// } )
					} catch (error) {
						reject(error)
					}
				})
			},
			drawRoundRect(ctx, x, y, w, h, r, color) {
				if (w < 2 * r) {
					r = w / 2;
				}
				if (h < 2 * r) {
					r = h / 2;
				}

				ctx.beginPath();
				ctx.fillStyle = color;

				ctx.arc(x + r, y + r, r, Math.PI, Math.PI * 1.5);
				ctx.moveTo(x + r, y);
				ctx.lineTo(x + w - r, y);
				ctx.lineTo(x + w, y + r);

				ctx.arc(x + w - r, y + r, r, Math.PI * 1.5, Math.PI * 2);
				ctx.lineTo(x + w, y + h - r);
				ctx.lineTo(x + w - r, y + h);

				ctx.arc(x + w - r, y + h - r, r, 0, Math.PI * 0.5);
				ctx.lineTo(x + r, y + h);
				ctx.lineTo(x, y + h - r);

				ctx.arc(x + r, y + h - r, r, Math.PI * 0.5, Math.PI);
				ctx.lineTo(x, y + r);
				ctx.lineTo(x + r, y);

				ctx.fill();
				ctx.closePath();
			},

			//隐藏海报
			faceToFaceHide() {
				faceToFace.value = false
			},

			getUserData() {
				this.$MyAxios.get('/api/user/invites/search/findByUsername', {
					params: {
						username: this.username,
					}
				}, response => {
					if (response.code == 1) {
						this.inviteInfo = response.data;
						this.showLoading = false;
						// let str =
						// 	// `https://www.xp.com/pages/login/login
						// 	`${window.location.protocol}//${window.location.host}/sign-in?type=0&language=${localStorage.getItem('bigLang') || 'CHINESE'}&registCode=${this.inviteInfo.inviteCode}`

						let https = this.DDNS && this.DDNS['download-new'] && this.DDNS['download-new'][0] || '';
						https = https +
							`/#/pages/login/index?theme=${this.theme == 'night' ? 'dark':'light'}&language=${localStorage.getItem('bigLang') || 'CHINESE'}&registCode=${this.inviteInfo.inviteCode}`
						let str = https


						this.inviteInfo.urlStr = str
						//跳转成功页
						// this.$router.push({
						// 	name: 'success-xp',
						// })

						// // 添加监听事件
						// var btn = document.getElementById( "invite-button" );
						// btn.addEventListener( "click", function() {
						// 	//  安卓
						// 	// debugger
						// 	if ( window.goInvite ) {
						// 		let str = JSON.stringify( response.data );
						// 		goInvite.setValue( str );
						// 	}

						// } );
						this.creatQrCode()
					}
				}, error => {
					this.showLoading = false;
					this.showAlert(error);
					this.creatQrCode()
				})
			},

			showAlert(message) {
				this.message = message;
				this.alertShow = true;
				setTimeout(() => {
					this.alertShow = false;
				}, 1500);
			},

			creatQrCode() {
				let str = this.inviteInfo.urlStr
				var qrcode = new QRCode(this.$refs.qrcode, {
					text: str, // 需要转换为二维码的内容
					width: 200,
					height: 200,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
				const canvas = this.$refs.qrcode.querySelector('canvas');
				// this.qrcodeCanvas = ;
				this.imgList.push(canvas.toDataURL('image/png'))
				// console.log(45, this.imgList)
				// new QRCode(this.$refs.qrCodeUrl, this.codeUrl);
			},
		}
	}
</script>

<style scoped lang='less'>
	@keyframes rotateZ {
		0% {
			transform: rotateZ(0deg);
		}

		100% {
			transform: rotateZ(360deg);
		}
	}

	.canvasRef {
		top: 0;
		left: 0;
		position: fixed;
		transform: translateX(-200vw);
	}

	#invitation-jgz {
		background-color: #ffffff;
		width: 100%;
		min-height: 100vh;
		position: relative;

		.h1 {
			text-align: center;
			font-weight: bold;
			font-size: 48px;
			padding: 80px 0;
		}

		.ewm {
			margin: 0 60px 80px 60px;
			display: flex;
			overflow: hidden;
			justify-content: space-between;
			position: relative;
			z-index: 2;

			.bg {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				z-index: -1;
			}

			.left {
				width: 300px;
				height: 300px;
				margin: 20px 0 20px 20px;
				border-radius: 20px;
				overflow: hidden;
				position: relative;

				.icon {
					width: 100%;
					height: 100%;
				}

				.icon2 {
					width: 80px;
					height: 80px;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					background: #ffffff;
					border: 8px solid #ffffff;
					border-radius: 0;
					overflow: hidden;
					box-sizing: content-box;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}

			.right {
				img {
					width: 188px;
					height: 240px;
					margin-right: 56px;
				}

				p {
					margin: 20px 20px 0 0;
					font-size: 28px;
					color: #1E2329;
					font-weight: bold;
				}
			}
		}

		.inputBox {
			margin: 0 60px 32px 60px;
			height: 88px;
			border: 1px solid #EAECEF;
			border-radius: 16px;
			padding: 0 32px;
			font-size: 28px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.text {
				color: #A1A6AE;
			}

			.num {
				color: #1E2329;
				display: flex;
				align-items: center;

				span {
					max-width: 280px;
					white-space: nowrap;
					text-overflow: ellipsis;
					overflow: hidden;
				}

				img {
					width: 40px;
					height: 40px;
					margin-left: 24px;
					cursor: pointer;
				}
			}
		}

		.h2 {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 120px;
			font-size: 26px;
			color: #A1A6AE;

			span {
				display: inline-block;
				width: 160px;
				height: 1px;
				background: #EAECEF;
				margin: 0 26px;
			}
		}

		.ul {
			display: flex;
			justify-content: space-around;
			margin-top: 48px;

			&.type-2 {
				margin-top: 80px;
				justify-content: start;

				.li {
					margin-right: 128px;
				}
			}

			.li {
				font-size: 24px;
				color: #1E2329;
				display: flex;
				justify-content: center;
				flex-wrap: wrap;
				flex-direction: column;
				align-items: center;

				.img {
					width: 88px;
					height: 88px;
					border: 1px solid #EAECEF;
					border-radius: 16px;
					margin-bottom: 24px;
					display: flex;
					justify-content: center;
					align-items: center;

					img {
						width: 40px;
						height: 40px;
					}
				}
			}
		}
	}

	.poster,
	.posterBG {
		position: fixed;
		left: 0;
		width: 100%;
	}

	.poster {
		padding: 80px 116px;
		border-radius: 20px 20px 0 0;
		background: #ffffff;
		z-index: 91;
		bottom: 0;
		transition: all 0.3s;
		transform: translate(0, 100%);

		&.on {
			transform: translate(0, 0);
		}

		.load {
			width: 100%;
			height: 280px;
			display: flex;
			align-items: center;
			justify-content: center;

			img {
				width: 80px;
				height: 80px;
				animation: rotateZ 2s linear 0s infinite;
			}
		}

		.hbImg {
			width: 100%;
			height: auto;
		}
	}

	.posterBG {
		top: 0;
		height: 100%;
		z-index: 90;
		background: rgba(0, 0, 0, 0.5);
		display: none;

		&.on {
			display: block;
		}
	}


	#invitation-jgz.page_night {
		.h1 {
			color: #ffffff;
		}

		.ewm {
			.right p {
				color: #fff;
			}

			.bg {}
		}

		.inputBox {
			border-color: #2A2A2A;

			.text {
				color: #6C757D;
			}

			.num {
				color: #fff;
			}
		}

		.ul .li p {
			color: #FFFFFF;
		}

		.poster {
			background: #161616;
		}

	}
</style>
